import {Sync} from '@client/sync'
import {PersonalChatProxy} from '@extensions/proxies/personal-chat-proxy'
import {DataObjectId, SandboxTree, Hub} from 'yougile-model'
import {getHub} from './get-hub'

export function getHubWithNewChat(idChat: DataObjectId): {
  box: SandboxTree
  hub: Hub
} {
  const {hub, box} = getHub(idChat)
  if (hub) {
    return {box, hub}
  }

  const toUser = Sync.getCurrentSandbox().getUser(idChat)
  if (!toUser) {
    throw new Error('Cannot find user for forwarding message')
  }

  const profileSandBox = Sync.getProfile()
  const chat = PersonalChatProxy.createForCurrentUser(toUser)
  const createdHub = profileSandBox.getHub(chat.chatId)

  return {box: profileSandBox, hub: createdHub}
}
